import { render, staticRenderFns } from "./SouthAfrica.vue?vue&type=template&id=a280bca4&"
import script from "./SouthAfrica.vue?vue&type=script&lang=js&"
export * from "./SouthAfrica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a280bca4')) {
      api.createRecord('a280bca4', component.options)
    } else {
      api.reload('a280bca4', component.options)
    }
    module.hot.accept("./SouthAfrica.vue?vue&type=template&id=a280bca4&", function () {
      api.rerender('a280bca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/SouthAfrica.vue"
export default component.exports